import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Form } from "../teacher/Drawers/DrawerSiniflarim";
import { db, auth } from "../../firebase";
import {
  getDocs,
  doc,
  query,
  collection,
  where,
  getDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  CustomLink,
  CustomLink2,
  DeleteButton,
} from "../../components/buttons/Button.styled";
import {
  Unit,
  UnitName,
  Text,
  Title,
  Main,
  Container,
  UnitDescription,
} from "../student/Drawers/studentDrawerKonularim";
import { InputSave, InputText, LabelSubtitle } from "../student/studentAyarlar";

function DrawerMyChildren() {
  const navigate = useNavigate();
  const [children, setChildren] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isPremium, setIsPremium] = useState(false);

  useEffect(() => {
    const fetchChildren = async () => {
      const currentUser = auth.currentUser;
      const currentUserUid = currentUser ? currentUser.uid : null;

      if (currentUserUid) {
        try {
          const userDoc = await getDoc(doc(db, "users", currentUserUid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setIsPremium(userData.premium === true);

            const myChildren = userData.myChildren || [];
            const childUids = myChildren.map((child) => child.uid);

            const childPromises = childUids.map(async (uid) => {
              const childDoc = await getDoc(doc(db, "users", uid));
              return childDoc.data();
            });

            const childData = await Promise.all(childPromises);
            setChildren(childData);
          }
        } catch (error) {
          console.error("Çocuk bilgilerini alma hatası:", error);
        }
      }
    };

    fetchChildren();
  }, []);

  const handleAddChild = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const emailAddress = formData.get("emailAddress");
    const activationCode = formData.get("activationCode");

    const currentUser = auth.currentUser;
    const currentUserUid = currentUser ? currentUser.uid : null;

    if (currentUserUid) {
      try {
        const userDocRef = doc(db, "users", currentUserUid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const userDocData = userDocSnap.data();
          const addedActivationCodes = userDocData.addedActivationCodes || [];

          if (!userDocData.premium) {
            const kodDurumuRef = doc(db, "kodlar", "kodlarDurumu");
            const kodDurumuSnap = await getDoc(kodDurumuRef);

            if (kodDurumuSnap.exists()) {
              const kodlar = kodDurumuSnap.data();

              if (!kodlar[activationCode]) {
                setErrorMessage("Geçersiz aktivasyon kodu.");
                return;
              }

              if (addedActivationCodes.includes(activationCode)) {
                setErrorMessage("Bu aktivasyon kodu zaten kullanılmış.");
                return;
              }

              await updateDoc(kodDurumuRef, {
                [activationCode]: false,
              });

              await updateDoc(userDocRef, {
                addedActivationCodes: arrayUnion(activationCode),
                premium: true,
              });
            } else {
              setErrorMessage("Kod veritabanına erişilemedi.");
              return;
            }
          }

          const q = query(
            collection(db, "users"),
            where("userData.email", "==", emailAddress)
          );
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const childUid = querySnapshot.docs[0].data().uid;

            await updateDoc(userDocRef, {
              myChildren: arrayUnion({ uid: childUid }),
            });

            await updateDoc(doc(db, "users", childUid), {
              parents: arrayUnion({ uid: currentUserUid }),
            });

            window.location.reload();
          } else {
            setErrorMessage("Kullanıcı bulunamadı.");
          }
        }
      } catch (error) {
        console.error("Çocuk ekleme hatası:", error);
      }
    }
  };

  const handleDeleteChild = async (childUid) => {
    const currentUser = auth.currentUser;
    const currentUserUid = currentUser ? currentUser.uid : null;
    const confirmDelete = window.confirm(
      "Bu çocuğu silmek istediğinizden emin misiniz?"
    );

    if (confirmDelete) {
      try {
        const parentQuery = query(
          collection(db, "users"),
          where("uid", "==", currentUserUid)
        );
        const parentSnapshot = await getDocs(parentQuery);

        if (!parentSnapshot.empty) {
          const parentDoc = parentSnapshot.docs[0];
          const childrenArray = parentDoc.data().myChildren || [];
          const updatedChildren = childrenArray.filter(
            (child) => child.uid !== childUid
          );

          await updateDoc(parentDoc.ref, { myChildren: updatedChildren });

          const childRef = doc(db, "users", childUid);
          const childData = (await getDoc(childRef)).data();
          const updatedParents = (childData.parents || []).filter(
            (p) => p.uid !== currentUserUid
          );
          await updateDoc(childRef, { parents: updatedParents });

          setChildren(updatedChildren);
          window.location.reload();
        }
      } catch (error) {
        console.error("Çocuk silme hatası:", error);
      }
    }
  };

  return (
    <Container>
      <Title>
        <Text>Takip Ettiğim Çocuğum</Text>
      </Title>
      <Main>
        <Unit>
          <UnitName style={{ color: "#674188", fontSize: "1.5rem" }}>
            Çocuk Adı
          </UnitName>
          <UnitDescription />
          <CustomLink2 />
        </Unit>

        {children.map((child) => (
          <Unit key={child.uid}>
            <UnitName>{child.userData && child.userData.displayName}</UnitName>
            <ButtonBlock>
              <CustomLink to={`/veli-ekrani/cocugumu-goruntule/${child.uid}`}>
                <Button>İlerlemesini Gör</Button>
              </CustomLink>
              <CustomLink>
                <DeleteButton onClick={() => handleDeleteChild(child.uid)}>
                  Takibi Bırak
                </DeleteButton>
              </CustomLink>
            </ButtonBlock>
          </Unit>
        ))}

        <Form onSubmit={handleAddChild}>
          {!isPremium && (
            <LabelSubtitle>
              Sayın velimiz, sadece bir çocuğunuzu takip edebilirsiniz. Bunun
              için aktivasyon kodu kullanmanız gereklidir. Kod almak için{" "}
              <Link to="/odeme-planlari">buraya</Link> tıklayınız. Sorun
              yaşarsanız <strong>0530 682 68 49</strong> ile iletişime
              geçebilirsiniz.
            </LabelSubtitle>
          )}

          <InputText
            type="text"
            name="emailAddress"
            placeholder="Çocuğunuzun mail adresi"
          />
          {!isPremium && (
            <InputText
              type="text"
              name="activationCode"
              placeholder="Aktivasyon Kodu"
            />
          )}
          <InputSave type="submit" value="Çocuk Ekle" />
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </Form>
      </Main>
    </Container>
  );
}

const ButtonBlock = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 70%;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  margin-top: 10px;
`;

export default DrawerMyChildren;
